import styled from 'styled-components'
import {fontFamily, fontSize, fontWeight} from "buoy-theme"
import { Label } from "buoy-core"

const DefaultLabel = styled.span`
  font-family: ${fontFamily};
  font-weight: ${fontWeight.light};
  color: ${props => props.theme.colors[props.color]};
  ${fontSize("bodyMain")};
`

Label.defaultProps = {color: 'neutralDark'}

const CardLabel = styled(Label)`
  margin: ${props => props.margin ? props.margin : '0'};
  letter-spacing: 0.6px;
`

export {DefaultLabel as default, CardLabel }


// WEBPACK FOOTER //
// ./assets/common/components/Label.js